import { TextField } from '@mui/material';
import { __SWEEP_DESIGN_TYPOGRAPHY_STYLES___ } from '@sweep-io/sweep-design';
import { SweepTypographyVariants } from '@sweep-io/sweep-design/dist/components/Typography/types';
import { memo, useCallback, useMemo } from 'react';

export const DialogHeaderTextField = memo(
  ({
    value,
    onChange,
    placeholder,
    maxLength,
    editDisabled,
    errorHelperText,
    typographyVariant = 'h3',
  }: {
    value: string;
    onChange: (value: string) => any;
    placeholder: string;
    maxLength?: number;
    editDisabled?: boolean;
    errorHelperText?: string;
    typographyVariant?: SweepTypographyVariants;
  }) => {
    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
      },
      [onChange],
    );

    const sx = useMemo(
      () => ({
        input: {
          fontSize: __SWEEP_DESIGN_TYPOGRAPHY_STYLES___[typographyVariant]?.fontSize,
          fontWeight: __SWEEP_DESIGN_TYPOGRAPHY_STYLES___[typographyVariant]?.fontWeight,
          lineHeight: __SWEEP_DESIGN_TYPOGRAPHY_STYLES___[typographyVariant]?.lineHeight,
          pt: typographyVariant === 'h3' ? 1 : undefined,
        },

        '& .MuiInput-input::placeholder': {
          fontSize: __SWEEP_DESIGN_TYPOGRAPHY_STYLES___[typographyVariant]?.fontSize,
          fontWeight: __SWEEP_DESIGN_TYPOGRAPHY_STYLES___[typographyVariant]?.fontWeight,
          lineHeight: __SWEEP_DESIGN_TYPOGRAPHY_STYLES___[typographyVariant]?.lineHeight,
        },
      }),
      [typographyVariant],
    );

    return (
      <TextField
        error={!!errorHelperText}
        disabled={editDisabled}
        fullWidth
        variant="standard"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        sx={sx}
        inputProps={{
          maxLength,
        }}
        helperText={errorHelperText}
      />
    );
  },
);

DialogHeaderTextField.displayName = 'DialogHeaderTextField';
